import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './tags.module.scss';

const Tags = ({tags}) => (
  <div className={styles.Tags}>
    <span className={classNames('has-text-white', styles.Tags__label)}>
      Popular:{' '}
    </span>
    <ul className={styles.Tags__list}>
      {tags.map(({title, href}) => (
        <li className={styles.Tags__tag} key={title}>
          <a
            className={classNames('button', 'is-info', styles.Tags__button)}
            href={href}
          >
            {title}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

Tags.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Tags;



// WEBPACK FOOTER //
// ./src/components/header/Tags.js